import { defineComponent as _defineComponent } from 'vue'
import {Nutritions} from "@/models/Recipes/Nutritions";
import {NutrientType} from "@/models/Ingredient/NutrientType";
import {NUTRIENT_UNIT_MAP, round} from "@/utils/Helpers";
import LockIcon from "@/components/icons/LockIcon.vue";
import VTrialMasker from "@/components/vTrialMasker.vue";
import {computed} from "vue";

type vSupplementLabelUSProps = {
  nutrition: Nutritions;
  showRoundedDv: boolean;
  servingsPerContainer: number;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'vSupplementLabelUS',
  props: {
    nutrition: null,
    showRoundedDv: { type: Boolean },
    servingsPerContainer: null
  },
  setup(__props: any) {

const props = __props as {
  nutrition: Nutritions;
  showRoundedDv: boolean;
  servingsPerContainer: number;
};



const servingSize = computed(() => {
  const d = props.nutrition.displayServingQuantityAndMeasure;
  return d ? `${round(d.item1, 2)} ${d.item2}` : "—";
});

const hasNoDV = computed(() => {
  return vitaminsAndMinerals.value.some((n) => getDv(n, props.showRoundedDv) === null);
});

const vitaminsAndMinerals = computed(() => {
  const nutrients: NutrientType[] = [
    NutrientType.VitaminA,
    NutrientType.VitaminC,
    NutrientType.VitaminD,
    NutrientType.VitaminE,
    NutrientType.VitaminK,
    NutrientType.Thiamine,
    NutrientType.Riboflavin,
    NutrientType.Niacin,
    NutrientType.VitaminB6,
    NutrientType.Folate,
    NutrientType.VitaminB12,
    NutrientType.Biotin,
    NutrientType.PantothenicAcid,
    NutrientType.Calcium,
    NutrientType.Iron,
    NutrientType.Phosphorus,
    NutrientType.Iodine,
    NutrientType.Magnesium,
    NutrientType.Zinc,
    NutrientType.Selenium,
    NutrientType.Copper,
    NutrientType.Manganese,
    NutrientType.Chromium,
    NutrientType.Molybdenum,
    NutrientType.Chloride,
    NutrientType.Choline,
    NutrientType.Potassium,
    NutrientType.Caffeine,
    NutrientType.Taurine,
  ];

  return nutrients.filter((nutrient) => {
    const value = props.nutrition.getRoundedValue(nutrient);
    return value !== 0 && value !== null && value !== undefined;
  });
});

function getUnit(nutrient: NutrientType) {
  const info = props.nutrition.getNutrientInfo(nutrient);
  if (!info) return "—";
  const unit = NUTRIENT_UNIT_MAP.get(nutrient);
  return `${unit}`;
}

function getNutrientLabel(nutrient: NutrientType): string {
  return NutrientType[nutrient].replace(/([A-Z])/g, " $1").trim();
}

function getNutrientDelegate(nutrientType: NutrientType, showRoundedDv: boolean) {
  return showRoundedDv
    ? round(props.nutrition.getRoundedValue(nutrientType), 2)
    : round(props.nutrition.getExactValue(nutrientType), 2);
}

function getDv(nutrientType: NutrientType, showRoundedDv: boolean) {
  return (showRoundedDv
    ? round(props.nutrition.getRoundedDailyValue(nutrientType), 0)
    : round(props.nutrition.getExactDailyValue(nutrientType), 2)) + '%';
}

return { __sfc: true,props, servingSize, hasNoDV, vitaminsAndMinerals, getUnit, getNutrientLabel, getNutrientDelegate, getDv, NutrientType, LockIcon, VTrialMasker }
}

})